import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnDestroy, PLATFORM_ID, Renderer2 } from '@angular/core';
import { ApiserviceService } from '../../apiservice.service';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ResponsiveUIService } from '../../../services/responsive-ui.service';
import { Subscribable, Subscription } from 'rxjs';

import { HelpSupportComponent } from "../../../shared/components/help-support/help-support.component";
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { DataLayerService } from '../../../shared/services/gtm-service/data-layer.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { RouterModule } from '@angular/router';
import { CarousalPageComponent } from '../../../shared/components/carousal-page/carousal-page.component';
import { CartService } from '../../../shared/services/cart.service';
import { SafePipe } from '../../../shared/pipes/safe.pipe';
import { SafehtmlPipe } from '../../../shared/pipes/safehtml.pipe';
import { TruncatePipe } from '../../../shared/pipes/truncate.pipe';
import { SchemaService } from '../../../shared/services/schema.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { ResponsiveHeightDirective } from '../../../shared/directives/responsive-height.directive';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, CarouselModule,RouterModule ,SafePipe, TruncatePipe, SafehtmlPipe, HttpClientModule, HelpSupportComponent,CarousalPageComponent, ResponsiveHeightDirective],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnDestroy, AfterViewInit{
bannerList:any = [];
homePageData:any;
webBannerList: any = [];
smallWebBannerList:any = [];
mobileBannerList:any = [];
smallMobileBannerList:any = [];
productCarousalData:any[] = [];
responsiveSub:Subscription=new Subscription();
sub:Subscription=new Subscription() 
deviceStatus:any;
autoplay: boolean=true;
imgLoaded: boolean = false;
phoneIcon = "https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/contact-us/phone.svg";
contactUs  ="https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/contact-us/email.svg";
customerSupport ="https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/customer-support/complaint-icon.svg";
customersuppoerRegister = "https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/customer-support/register.svg";
contactUs_chat = "https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/contact-us/chat.svg"
countSectionImg: any = [
  "https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/inbt-homepage/countries.svg",
  "https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/inbt-homepage/customer.svg",
  "https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/inbt-homepage/Distributor.svg",
  "https://lumuatsta.blob.core.windows.net/uatcontainer/assets/images/inbt-homepage/Dealer.svg"
]
customOptions: OwlOptions = {
  loop: true,
  autoplay: true,
  mouseDrag: true,
  touchDrag: true,
  dots: true,
  navSpeed: 600,
  nav: false,
  navText: ['', ''],
  stagePadding: 0,
  center: true,
  margin: 0,
  responsive: {
    0: {
      items: 1
    }
  },
};
genericOptions: OwlOptions = {
  loop: true,
  mouseDrag: true,
  touchDrag: true,
  pullDrag: false,
  autoplay: false,
  dots: true,
  navSpeed: 600,
  nav: false,
  stagePadding: 50,
  margin: 25,
  navText: ['', ''],
  responsive: {
    0: {
      items: 1
    },
    575: {
      items: 2
    },
    768: {
      items: 2
    },
    900: {
      items: 3
    },
    1200: {
      items: 4
    },
  },
};
cartObject: any = [];
  actualSchemaValue!: any;
  script: any;

constructor(
  private Apiserv:ApiserviceService,
  private responsivSrv: ResponsiveUIService,
  private http:HttpClient,
  public analyticsService: AnalyticsService,
  private _dataLayerService: DataLayerService,
  public utils: UtilsService,
  public CartService: CartService,
  @Inject(PLATFORM_ID) private platformId: Object,
  @Inject(DOCUMENT) private _document: Document,
  private _renderer2: Renderer2,
  private schemaService: SchemaService,
  private metaSvc: MetaMgmtService,
){
  this.responsiveSub = this.responsivSrv.getDeviceStatus().subscribe((res:any) => {
    if(res){
      this.deviceStatus = res
    }else{}
  })
  this.http.get("https://uatapi.luminousindia.com/customer/api/LandingPage/GetCustomerBrandLandingPage").subscribe((res:any) => {
    if(res){
    this.homePageData = res;
    this.processData()
    }else{

    }
  })
  if (!this.isSchemaAdded()) {
    this.callSchema();
  }

}
private isSchemaAdded(): boolean {
  const existingSchema = this._document.querySelector('script[type="application/ld+json"]');
  return !!existingSchema;
}
ngOnInit(): void {
  this.sub.add( this.CartService.cartData$.subscribe(
     (data: any) => {
       this.cartObject = data ? data : []
     }))

 }
 async callSchema(){
  this.actualSchemaValue = await this.schemaService.gethomeSchema();
  this.script  = this._renderer2.createElement('script');
  this.script.type = `application/ld+json`;
  this.script.text = JSON.stringify(this.actualSchemaValue);
  this.script.defer = true;
  this.script.setAttribute('nonce', 'lumi12');
  this._renderer2.appendChild(this._document.body, this.script);
}
 ngAfterViewInit() {
   if (this.homePageData?.mainBannerResponse && this.homePageData?.mainBannerResponse.length > 1) {
     this.utils.customOptionsForBanner.loop = true;
   }
   this.imgLoaded = true;
 }

processData() {
  if (this.homePageData && this.homePageData.mainBannerResponse && this.homePageData.mainBannerResponse.length) {
    this.mobileBannerList = [];
    this.webBannerList = [];
    this.homePageData.mainBannerResponse.forEach((element: any) => {
      let mobileBanner = {
        image: element.mobileImageFile,
        link: element.ctaLink,
        altTag: element.altTag,
        guidId: element.guidId,
        isSmallBanner: element.isSmallBanner,
        filename: element.mobileImageFileName
      }
      let webBanner = {
        image: element.webImageFile,
        link: element.ctaLink,
        altTag: element.altTag,
        guidId: element.guidId,
        isSmallBanner: element.isSmallBanner,
        filename: element.webImageFileName
      }
      if (!element.isSmallBanner) {
        if(webBanner.link != 'https://uat.luminousindia.com/'){
          this.webBannerList.push(webBanner);
        }else{}
     
        this.mobileBannerList.push(mobileBanner);
      }
    });
    if (this.webBannerList && this.webBannerList.length > 1) {
    }


  }
  if (this.homePageData && this.homePageData.smallBannerResponse && this.homePageData.smallBannerResponse.isSmallBanner) {
    let bannerData = this.homePageData.smallBannerResponse;
    this.smallMobileBannerList = [];
    this.smallWebBannerList = [];
    let mobileBanner = {
      image: bannerData.mobileImageFile,
      link: bannerData.ctaLink,
      altTag: bannerData.altTag,
      guidId: bannerData.guidId,
      isSmallBanner: bannerData.isSmallBanner,
      filename: bannerData.mobileImageFileName
    }
    let webBanner = {
      image: bannerData.webImageFile,
      link: bannerData.ctaLink,
      altTag: bannerData.altTag,
      guidId: bannerData.guidId,
      isSmallBanner: bannerData.isSmallBanner,
      filename: bannerData.webImageFileName
    }
    this.smallWebBannerList.push(webBanner);
    this.smallMobileBannerList.push(mobileBanner);
    if (this.smallWebBannerList && this.smallWebBannerList.length > 1) {
    }


  }
  if (this.homePageData && this.homePageData.brandLandingPageOurProductsResponse && this.homePageData.brandLandingPageOurProductsResponse.length) {
    this.productCarousalData = [];
    this.homePageData.brandLandingPageOurProductsResponse.forEach((element: any) => {
      let obj = {
        image: element.productImage,
        description: element.productName,
        price: element.productPrice ? element.productPrice : '0',
        altTag: element.productImageAltTag ? element.productImageAltTag : 'product',
        productGuid: element.productGuidId
      }
      this.productCarousalData.push(obj);
    });
  }
  this.metaSvc.updateMetaTags(this.homePageData.metaInfoResponse);
}

handleSlideChange(event: any, type: string) {
  let currentSlideData: any;
  let slideList: any[];
  if (this.autoplay) {
    currentSlideData = this.homePageData?.mainBannerResponse[event.startPosition];
    slideList = this.homePageData?.mainBannerResponse;
    currentSlideData.creativeSlot = event.startPosition + 1;
  }
}
triggerBannerClick(bannerData: any) {
  const data = {
    eventName: "Banner Clicked",
    eventData: {
      'Banner Name': bannerData.altTag,
    }
  };
  this.analyticsService.trackData(data);
  this._dataLayerService.triggerPromotionEvents(bannerData, 'select_promotion');
}
categoryCLickHandler(categoryData: any) {
  let url = ''
  if (this.utils.checkValidityOfGuid(categoryData.landingPageGuid)) {
    let catTitle = this.utils.createNameForUrl(categoryData.categoryName);
    if (categoryData.landingType && categoryData.landingType.toLowerCase() == 'solarcategorylanding') {
      url = `/category/solar/${catTitle}`
    }
    else {
      url = `/category/energy-storage/${catTitle}`
    }
  }
  return url;
}
triggerCategoryClicked(catTitle: string) {
  const data = {
    eventName: "Category Clicked",
    eventData: {
      'Category Name': catTitle
    }
  };
  this.analyticsService.trackData(data);
}
onProductClick(data: any) {
  if (isPlatformBrowser(this.platformId)) {
  localStorage.setItem('source', 'Brand');
}}
ngOnDestroy(): void {

  this.sub.unsubscribe()
}
}
